import axios from 'axios'
import Moment from 'moment'
import { saveAs } from 'file-saver'
import { GetDateForApiWithFormat } from '../utils/dateTime'
import {
  FETCH_DONE, FETCH_FAILED, CONTENT_FETCH_DONE, SUBMIT_DONE, SUBMIT_FAILED,
  LATEST_CONTENT_FETCH_DONE, LATEST_CONTENT_FETCH_FAILED, FETCH_STARTED,
  SEARCH_STARTED, SEARCH_DONE, SEARCH_FAILED, SEARCH_CAT_DONE,
  SEARCH_CAT_STARTED, SEARCH_CAT_FAILED, SAVED_SEARCH_FETCH_DONE, SAVED_SEARCH_FETCH_FAILED,
  SAVED_SEARCH_SUBMIT_DONE, SAVED_SEARCH_SUBMIT_FAILED,
  FETCH_PDF_STARTED, FETCH_PDF_DONE, FETCH_PDF_FAILED, FETCH_CONFERENCE_STARTED, FETCH_CONFERENCE_DONE, FETCH_CONFERENCE_FAILED,
  IMPERSONATE_USER_STARTED, IMPERSONATE_USER_DONE, IMPERSONATE_USER_FAILED, EMAIL_CONFIRMATION_STARTED, EMAIL_CONFIRMATION_DONE, EMAIL_CONFIRMATION_FAILED
} from './actionTypes'
import { EDITORIALACCESS } from '../utils/constants'

// Ie 11 fix

const ES6Promise = require('es6-promise')
ES6Promise.polyfill()
axios.defaults.headers.Pragma = 'no-cache'

const searchStarted = (payload) => ({
  type: SEARCH_STARTED,
  payload
})

const fetchDone = (payload) => ({
  type: FETCH_DONE,
  payload
})

const contentFetchStarted = (payload) => ({
  type: FETCH_STARTED,
  payload
})

const contentFetchDone = (payload) => ({
  type: CONTENT_FETCH_DONE,
  payload
})

const fetchFailed = (payload) => ({
  type: FETCH_FAILED,
  payload
})

const latestContentFetchDone = (payload) => ({
  type: LATEST_CONTENT_FETCH_DONE,
  payload
})

const latestContentFetchFailed = (payload) => ({
  type: LATEST_CONTENT_FETCH_FAILED,
  payload
})

const submitDone = (payload) => ({
  type: SUBMIT_DONE,
  payload
})

const submitFailed = (payload) => ({
  type: SUBMIT_FAILED,
  payload
})

const searchDone = (payload) => ({
  type: SEARCH_DONE,
  payload
})

const searchFailed = (payload) => ({
  type: SEARCH_FAILED,
  payload
})

const searchCatStarted = (payload) => ({
  type: SEARCH_CAT_STARTED,
  payload
})

const searchCatDone = (payload) => ({
  type: SEARCH_CAT_DONE,
  payload
})

const searchCatFailed = (payload) => ({
  type: SEARCH_CAT_FAILED,
  payload
})

const savedSearchFetchDone = (payload) => ({
  type: SAVED_SEARCH_FETCH_DONE,
  payload
})

const savedSearchFetchFailed = (payload) => ({
  type: SAVED_SEARCH_FETCH_FAILED,
  payload
})

const savedSearchSubmitDone = (payload) => ({
  type: SAVED_SEARCH_SUBMIT_DONE,
  payload
})

const savedSearchSubmitFailed = (payload) => ({
  type: SAVED_SEARCH_SUBMIT_FAILED,
  payload
})

const fetchPdfStarted = (payload) => ({
  type: FETCH_PDF_STARTED,
  payload
})

const fetchPdfDone = (payload) => ({
  type: FETCH_PDF_DONE,
  payload
})

const fetchPdfFailed = (payload) => ({
  type: FETCH_PDF_FAILED,
  payload
})

const fetchConferenceStarted = (payload) => ({
  type: FETCH_CONFERENCE_STARTED,
  payload
})

const fetchConferenceDone = (payload) => ({
  type: FETCH_CONFERENCE_DONE,
  payload
})

const fetchConferenceFailed = (payload) => ({
  type: FETCH_CONFERENCE_FAILED,
  payload
})

const impersonateUserStarted = (payload) => ({
  type: IMPERSONATE_USER_STARTED,
  payload
})

const impersonateUserDone = (payload) => ({
  type: IMPERSONATE_USER_DONE,
  payload
})

const impersonateUserFailed = (payload) => ({
  type: IMPERSONATE_USER_FAILED,
  payload
})

const confirmationEmailStarted = (payload) => ({
  type: EMAIL_CONFIRMATION_STARTED,
  payload
})

const confirmationEmailDone = (payload) => ({
  type: EMAIL_CONFIRMATION_DONE,
  payload
})

const confirmationEmailFailed = (payload) => ({
  type: EMAIL_CONFIRMATION_FAILED,
  payload
})

export const fetchContent = (payload) => async (dispatch) => {
  if (payload.id === 0) {
    return dispatch(fetchFailed({ error: 'Error invalid state' }))
  }
  let apiUrl = payload.apiUrl

  apiUrl = `${apiUrl}${payload.id}`

  dispatch(contentFetchStarted())

  await axios.get(apiUrl).then((res) => {
    return dispatch(contentFetchDone({ data: res.data }))
  })
    .catch(err => {
      return dispatch(fetchFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const fetchPreferences = () => async (dispatch) => {
  let apiUrl = `${process.env.API_USER_PREFERENCES}`

  if (sessionStorage.getItem('userData') != null) {
    var userData = JSON.parse(sessionStorage.getItem('userData'))

    apiUrl = `${apiUrl}?impersonateUserId=${userData.id}`
  }

  await axios.get(apiUrl).then((res) => {
    return dispatch(fetchDone({ data: res.data }))
  })
    .catch(err => {
      return dispatch(fetchFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const updatePreferences = (request) => async (dispatch) => {
  let apiUrl = `${process.env.API_USER_PREFERENCES}`

  if (sessionStorage.getItem('userData') != null) {
    var userData = JSON.parse(sessionStorage.getItem('userData'))

    apiUrl = `${apiUrl}?impersonateUserId=${userData.id}`
  }

  await axios.put(apiUrl, request).then((res) => {
    dispatch(submitDone(request))
  })
    .catch(err => {
      return dispatch(submitFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const fetchLatestContents = () => async (dispatch) => {
  const apiUrl = `${process.env.API_LATEST_CONTENT}`
  await axios.get(apiUrl).then((res) => {
    return dispatch(latestContentFetchDone({ data: res.data }))
  })
    .catch(err => {
      return dispatch(latestContentFetchFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const searchContent = (searchTerm, ids, pageNumber, aois, industries, geos, topics, contentTypes, dateFrom, dateTo, sortOrder, userRole) => async (dispatch) => {
  var apiUrl = `${process.env.API_SEARCH_CONTENT}`
  pageNumber = pageNumber || '1'

  dateFrom = dateFrom !== undefined ? Moment(dateFrom).format('YYYYMMDD') : ''
  dateTo = dateTo !== undefined ? Moment(dateTo).format('YYYYMMDD') : ''

  var ignoreAois = (userRole === EDITORIALACCESS ? false : true)

  apiUrl = `${apiUrl}q=${encodeURIComponent(searchTerm.trim())}&ids=${encodeURIComponent(ids)}&aois=${aois}&industries=${industries}&geos=${geos}&topics=${topics}&contentTypes=${contentTypes}&dateFrom=${dateFrom}&dateTo=${dateTo}&pgn=${encodeURIComponent(pageNumber)}&sortOrder=${sortOrder}&ignoreAois=${ignoreAois}`

  dispatch(searchStarted())

  await axios.get(apiUrl).then((res) => {
    return dispatch(searchDone({ data: res.data }))
  })
    .catch(err => {
      return dispatch(searchFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const searchCategories = (searchTerm, aois, industries, geos, topics, contentTypes, dateFrom, dateTo) => async (dispatch) => {
  var apiUrl = `${process.env.API_SEARCH_FACET}`
  apiUrl = `${apiUrl}q=${encodeURIComponent(searchTerm.trim())}&aois=${aois}&industries=${industries}&geos=${geos}&topics=${topics}&contentTypes=${contentTypes}&dateFrom=${dateFrom}&dateTo=${dateTo}`

  dispatch(searchCatStarted())

  await axios.get(apiUrl).then((res) => {
    return dispatch(searchCatDone({ data: res.data }))
  })
    .catch(err => {
      return dispatch(searchCatFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const fetchSavedSearches = () => async (dispatch) => {
  let apiUrl = `${process.env.API_SAVED_SEARCHES}`

  if (sessionStorage.getItem('userData') != null) {
    var userData = JSON.parse(sessionStorage.getItem('userData'))

    apiUrl = `${apiUrl}?impersonateUserId=${userData.id}`
  }

  await axios.get(apiUrl).then((res) => {
    return dispatch(savedSearchFetchDone({ data: res.data }))
  })
    .catch(err => {
      return dispatch(savedSearchFetchFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const updateSavedSearches = (request) => async (dispatch) => {
  let apiUrl = `${process.env.API_SAVED_SEARCHES}`

  if (sessionStorage.getItem('userData') != null) {
    var userData = JSON.parse(sessionStorage.getItem('userData'))

    apiUrl = `${apiUrl}?impersonateUserId=${userData.id}`
  }

  await axios.put(apiUrl, request).then((res) => {
    dispatch(savedSearchSubmitDone(request))
  })
    .catch(err => {
      return dispatch(savedSearchSubmitFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const fetchAndSavePdfContent = (request) => async (dispatch) => {
  const apiUrl = `${process.env.API_FETCH_PDF}`
  document.getElementById('divDownloading').className = 'show-download'

  await axios.post(apiUrl, request, { responseType: 'blob' }).then((res) => {
    const blob = new Blob([res.data], { type: request.fileType == 'zip' ? 'application/zip' : 'application/pdf' })
    saveAs(blob, request.fileName)

    document.getElementById('divDownloading').className = 'hide-loader'
    document.getElementById('divDownloaded').className = 'show-download'
    dispatch(fetchPdfDone())
    setTimeout(() => {
      document.getElementById('divDownloaded').className = 'hide-loader'
    }, 5000)
  })
    .catch(err => {
      document.getElementById('divDownloading').className = 'hide-loader'
      document.getElementById('divDownloaded').className = 'hide-loader'
      return dispatch(fetchPdfFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const fetchConferences = () => async (dispatch) => {
  var apiUrl = `${process.env.API_CONFERENCE_LISTING}`

  var dateFrom = new Date()

  dateFrom = dateFrom.setMonth(dateFrom.getMonth() - 2)
  var dtFrom = new Date(dateFrom)
  dtFrom = dtFrom.setDate(1)

  var dateTo = new Date()
  dateTo = dateTo.setMonth(dateTo.getMonth() + 12)

  apiUrl = `${apiUrl}datefrom=${GetDateForApiWithFormat(dtFrom)}&dateto=${GetDateForApiWithFormat(dateTo)}`

  await axios.get(apiUrl).then((res) => {
    return dispatch(fetchConferenceDone({ data: res.data }))
  })
    .catch(err => {
      return dispatch(fetchConferenceFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const impersonateUser = (impersonateUserId) => async (dispatch) => {
  var apiUrl = `${process.env.API_IMPERSONATE_USER}`

  apiUrl = `${apiUrl}/${impersonateUserId}`

  dispatch(impersonateUserStarted())

  await axios.get(apiUrl).then((res) => {
    return dispatch(impersonateUserDone({ data: res.data }))
  })
    .catch(err => {
      return dispatch(impersonateUserFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const sendConfirmationEmail = (impersonateUserId) => async (dispatch) => {
  var apiUrl = `${process.env.API_SEND_CONFIRMATION_EMAIL}${impersonateUserId}`

  dispatch(confirmationEmailStarted())

  await axios.put(apiUrl).then((res) => {
    return dispatch(confirmationEmailDone({ data: res.data }))
  })
    .catch(err => {
      return dispatch(confirmationEmailFailed({ error: `Error ${err.message}: ${err.stack}` }))
    })
}

export const actions = {
  fetchDone,
  fetchFailed,
  submitDone,
  submitFailed,
  fetchContent,
  contentFetchDone,
  fetchPreferences,
  updatePreferences,
  latestContentFetchDone,
  fetchLatestContents,
  latestContentFetchFailed,
  contentFetchStarted,
  searchStarted,
  searchContent,
  searchDone,
  searchFailed,
  searchCategories,
  searchCatStarted,
  searchCatDone,
  searchCatFailed,
  savedSearchFetchDone,
  savedSearchFetchFailed,
  savedSearchSubmitDone,
  savedSearchSubmitFailed,
  fetchSavedSearches,
  updateSavedSearches,
  fetchPdfStarted,
  fetchPdfDone,
  fetchPdfFailed,
  fetchAndSavePdfContent,
  fetchConferenceStarted,
  fetchConferenceDone,
  fetchConferenceFailed,
  fetchConferences,
  impersonateUserStarted,
  impersonateUserDone,
  impersonateUserFailed,
  impersonateUser,
  confirmationEmailStarted,
  confirmationEmailDone,
  confirmationEmailFailed,
  sendConfirmationEmail
}
